export default "__VITE_ASSET__3435a46e__"